import { render, staticRenderFns } from "./edit-json.vue?vue&type=template&id=57b963b4&scoped=true&"
import script from "./edit-json.vue?vue&type=script&lang=js&"
export * from "./edit-json.vue?vue&type=script&lang=js&"
import style0 from "./edit-json.vue?vue&type=style&index=0&lang=css&"
import style1 from "./edit-json.vue?vue&type=style&index=1&id=57b963b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b963b4",
  null
  
)

export default component.exports